import React from "react";
import {
  Select,
  Input,
  MenuItem,
  CircularProgress,
  Button,
  Stack,
  Link,
  InputLabel,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const CustomModal = ({
  loadingFlag,
  finishedFlag,
  productInfo,
  orderlistInfo,
  selectedCategory,
  errorInfo,
  action,
  handleCategoryChange,
  dismissCustomModal,
  sendRequest,
  toggleCustomModal,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          <small>
            Quick links:
            <Stack spacing={2} direction="row">
              {productInfo ? (
                <Link href={`/product/${productInfo.upc}`} target="_blank">
                  Product
                </Link>
              ) : (
                <></>
              )}
              <Link href={`/product/${productInfo.upc}`} target="_blank">
                Customer Location
              </Link>
            </Stack>
          </small>
          <br />
          {action ? (
            <>
              {orderlistInfo.map((oiItem) => (
                <>
                  <b>{oiItem.company_location_name}</b>
                  <br />
                  <InputLabel shrink id="category_label">
                    Category
                  </InputLabel>
                  <Select
                    fullWidth
                    name={`${oiItem.id}-category`}
                    input={<Input />}
                    value={
                      selectedCategory === null
                        ? ""
                        : selectedCategory[oiItem.id] || ""
                    }
                    onChange={handleCategoryChange}
                  >
                    <MenuItem value="">
                      <em>- None -</em>
                    </MenuItem>
                    {oiItem &&
                      oiItem.categories.map((item, index) => (
                        <MenuItem key={`category_${index}`} value={index}>
                          {item.category_name}
                        </MenuItem>
                      ))}
                  </Select>
                </>
              ))}
            </>
          ) : (
            <>
              Are you sure you want to remove <b>{productInfo.name}</b> from the
              selected orderlist?
            </>
          )}
          <br />
          <br />
          <Stack spacing={2} direction="row" justifyContent="right">
            <Button onClick={() => dismissCustomModal()}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              disabled={action ? selectedCategory === null : false}
            >
              {action ? "Save" : "Continue"}
            </Button>
          </Stack>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              {`${orderlistInfo === null ? "Loading" : "Saving"} information`}
              <br />
              This may take some time relative to the product and orderlist size
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              {`There was an error while ${
                orderlistInfo === null ? "loading" : "saving"
              } the product nor orderlist information`}
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => toggleCustomModal()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The changes on the product and orderlist were saved successfully.
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => dismissCustomModal()}
              className={classes.button}
            >
              Continue
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default CustomModal;